import {
  Box,
  CircularProgress,
  Modal,
  TextField,
  Typography,
} from "@mui/material"
import React, { useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import useStyles from "./useStyles"
import { useDispatch } from "react-redux"

import {
  addNewSearchValueOrg,
  getAllOrganizations,
  getOrganizationWithCUIT,
} from "../../../redux/actions/Organizations"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 200,
  bgcolor: "white",
  p: 4,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
}

export const ButtonSearchModal = ({
  setLoading,
  setRows,
  setopenFilterByType,
  setvalueFilter,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [error, seterror] = useState(false)
  const [errorText, seterrorText] = useState("")
  const [openSearchModal, setopenSearchModal] = useState(false)
  const [CUIT, setCUIT] = useState("")

  const valoresAceptados = /^[0-9]+$/

  const validateCUIT = (number) => {
    const valoresAceptados = /^[0-9]+$/
    return !!(number.match(valoresAceptados) && number.length === 11)
  }

  const handleChange = (e) => {
    setCUIT(e.target.value)
    if (e.target.value !== "") {
      if (
        !e.target.value.match(valoresAceptados) ||
        e.target.value.length > 11
      ) {
        seterrorText("El CUIT debe contener 11 números, sin guiones")
        seterror(true)
      } else {
        seterror(false)
      }
    } else {
      seterror(false)
    }
  }

  const handleClose = () => {
    setopenSearchModal(false)
  }

  const handleGetOrgsCandidates = async () => {
    const param = {
      organizationCuit: CUIT,
    }
    const response = await dispatch(getAllOrganizations(param))

    setRows(response)
    setvalueFilter(CUIT)
    dispatch(addNewSearchValueOrg(CUIT))
    handleClose()
    setopenFilterByType(false)
  }

  const isExists = async () => {
    setLoading(true)
    setShowCircularProgress(true)
    const response = await dispatch(getOrganizationWithCUIT(CUIT))

    if (response === "Organization not found") {
      seterrorText("No existe una organización con el CUIT ingresado")
      seterror(true)
      setLoading(false)
      setShowCircularProgress(false)
      return
    }
    await handleGetOrgsCandidates()
    setLoading(false)
    setShowCircularProgress(false)
  }

  const handleSearchSubmit = async (event) => {
    if (
      event.type === "keydown" &&
      event.key === "Enter" &&
      validateCUIT(CUIT)
    ) {
      await isExists()
    }
  }

  return (
    <>
      <button
        className={classes.buttonsearch}
        onClick={() => {
          setopenSearchModal(true)
        }}
      >
        <SearchIcon className={classes.searchIconButton} />
        <Typography className={classes.typographyButton}>
          Buscar por CUIT
        </Typography>
      </button>
      <Modal
        open={openSearchModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: "medium",
              ml: 50,
              color: "#263057",
              cursor: "pointer",
            }}
            onClick={handleClose}
          />
          <Typography
            sx={{ fontFamily: "Raleway", color: "#263057" }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Buscar organización por CUIT
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.typography}
          >
            Ingrese el CUIT de la organización que desea buscar.
          </Typography>
          <TextField
            sx={{ width: "70%" }}
            autoFocus
            margin="dense"
            id="name"
            type="text"
            value={CUIT}
            onChange={handleChange}
            onKeyDown={handleSearchSubmit}
            placeholder={"Ej: 30582622945"}
            variant="standard"
            error={error}
            helperText={error ? errorText : ""}
          />

          <Box className={classes.buttons}>
            {validateCUIT(CUIT) ? (
              <ButtonConfirm
                isExists={isExists}
                showCircularProgress={showCircularProgress}
              />
            ) : (
              <ButtonConfirmDisabled />
            )}
            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({ isExists, showCircularProgress }) {
  const classes = useStyles()

  return (
    <button
      className={classes.confirmButton}
      // onClick={handleAddExtend}
    >
      {showCircularProgress ? (
        <CircularProgress size="1.5rem" color="inherit" />
      ) : (
        <Typography
          onClick={isExists}
          className={classes.confirmButtonTypography}
          variant="contained"
        >
          Buscar
        </Typography>
      )}
    </button>
  )
}

function ButtonConfirmDisabled() {
  const classes = useStyles()

  return (
    <button className={classes.confirmButtonDisabled}>
      <Typography className={classes.confirmButtonTypography}>
        BUSCAR
      </Typography>
    </button>
  )
}
function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
